/*  MUI  */
import { Box, List } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { IconForSidebarListItem } from './SidebarIcons';
import { SidebarListItem } from './SidebarListItem';

/**
 * Component that renders the global navigation links in the sidebar
 * @param {Object} props - Component props
 * @param {string | undefined} [props.page] - Current active page identifier
 * @returns {JSX.Element} List of sidebar navigation items for global admin section
 */
export const SidebarGlobalLinks = ({
    page
}: {
    page?: string;
}): JSX.Element => {
    const { t } = useTranslation();

    return (
        <List
            aria-labelledby="nested-list-subheader"
            component="nav"
            style={{ display: 'flex', flexDirection: 'column' }}
        >
            <Box mt="8px" data-testid="sidebarGlobalLinks">
                <SidebarListItem
                    icon={<IconForSidebarListItem src="Network2" />}
                    id="global_tenants"
                    name={t('Common.tenant')}
                    permission="global_system_admin"
                    route="/globaladmin/tenant"
                    selected={page === 'globalAdminTenants'}
                />
                <SidebarListItem
                    icon={<IconForSidebarListItem src="Apps" />}
                    id="global_apps"
                    name={t('Common.application')}
                    permission={['super_admin', 'global_system_admin']}
                    route="/globaladmin/application"
                    selected={page === 'globalAdminApplications'}
                />
                <SidebarListItem
                    icon={<IconForSidebarListItem src="WarningTriangle" />}
                    id="global_vendorIncidents"
                    name={t('Common.vendor_incident')}
                    permission={['super_admin', 'global_system_admin']}
                    route="/globaladmin/vendorIncident"
                    selected={page === 'globalAdminVendorIncidents'}
                />
                <SidebarListItem
                    icon={<IconForSidebarListItem src="TaskList" />}
                    id="global_notes"
                    name={t('Common.notelio')}
                    permission={['super_admin', 'global_system_admin']}
                    route="/globaladmin/notes"
                    selected={page === 'globalAdminNotes'}
                />
                <SidebarListItem
                    icon={<IconForSidebarListItem src="Users" />}
                    id="global_users"
                    name={t('Common.user')}
                    permission="global_system_admin"
                    route="/globaladmin/user"
                    selected={page === 'globalAdminUsers'}
                />
                <SidebarListItem
                    icon={<IconForSidebarListItem src="OpenFolder" />}
                    id="global_categories"
                    name={t('Common.category')}
                    permission={['super_admin', 'global_system_admin']}
                    route="/globaladmin/category"
                    selected={page === 'globalAdminCategory'}
                />
                <SidebarListItem
                    icon={<IconForSidebarListItem src="LibraryBook" />}
                    id="global_publishers"
                    name={t('Common.publisher')}
                    permission={['super_admin', 'global_system_admin']}
                    route="/globaladmin/publisher"
                    selected={page === 'globalAdminPublisher'}
                />

                <SidebarListItem
                    icon={<IconForSidebarListItem src="Dashboard" />}
                    id="global_dashboard"
                    name={t('Common.dashboard')}
                    permission={['super_admin', 'global_system_admin']}
                    route="/globaladmin/dashboards/playground"
                    selected={page === 'dashboards'}
                />

                <SidebarListItem
                    icon={<IconForSidebarListItem src="Tools" />}
                    id="global_utilities"
                    name={t('Common.utilities')}
                    permission={['super_admin', 'global_system_admin']}
                    route="/globaladmin/configure"
                    selected={page === 'globalAdminConfigure'}
                />
            </Box>
        </List>
    );
};
